<template>
<div class="chapter">
<div class="inner_page">
<p class="part"><span>The First Trumpet<br/>Paybacks</span></p>
<p class="ct1"><span>Sunday, November 15; 11:30 <span class="small">P.M.</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// First.vue?e0feeb66